import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Route } from 'react-router-dom';
import { withProps } from 'recompose';

const ButtonStyles = css`
  all: unset;
  position: relative;
  font-size: 18px;
  font-family: ${props => props.theme.fonts.quicksand};
  font-weight: ${props => (props.active ? 'bold' : 'regular')};
  color: ${props => (props.active ? props.theme.colors.brand : props.theme.colors.mutedText)};
  padding: 1em;
  cursor: pointer;
`;

export const ExternalLink = withProps({
  target: '_blank',
  rel: 'noopener noreferrer',
})(styled.a`
  ${ButtonStyles};
`);

const StyledButton = styled.button`
  ${ButtonStyles};
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
  &:hover {
    background: #F5EEF8;
  };
  width: 170px;     
`;

const StoryFilterLink = ({ handleClick, path, children, ...props }) => (
  <Route path={path}>
    {({ match, history: { push } }) => (
      <StyledButton
        type="button"
        active={match && match.isExact}
        onClick={() => {
          handleClick();
          push(path);
        }}
        {...props}
      >
        {children}
      </StyledButton>
    )}
  </Route>
);

StoryFilterLink.propTypes = {
  handleClick: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default StoryFilterLink;
